export const CLIENT_TYPES = {
  PORTAL: 'portal',
  VSCODE: 'vscode',
  JETBRAINS: 'jetbrains',
  VISUAL_STUDIO: 'visual-studio',
  COMMAND: 'command',
  AWARE: 'aware',
  CLI: 'cli',
  TOOLBOX: 'toolbox',
} as const;

/**
 * Clients that run the CLI device-code login flow. `toolbox` (the Qodo Toolbox:
 * CLI + QAR + SDK) drives the same flow as `cli`, so device-confirm gates test
 * membership here rather than `=== CLIENT_TYPES.CLI`, keeping the two in lockstep
 * as `toolbox` supersedes the `cli` wire name.
 */
export const CLI_LIKE_CLIENTS: string[] = [
  CLIENT_TYPES.CLI,
  CLIENT_TYPES.TOOLBOX,
];

/**
 * Clients that are required to see the login page.
 * This is used to redirect the user to the login page if they are not logged in and the client is not in this list.
 * It is used to handle cases where the user has logged in via the portal, but did not login via the non-saas client (e.g ide or qodo-command)
 * The basic assumption is that if the user has arrived to the portal with the init_client query param set to a non-saas client,
 *  they are not logged in (otherwise they would not have arrived to the portal with this query param).
 */
export const LOGIN_REQUIRED_CLIENTS = [
  'jetbrains',
  'vscode',
  'visual-studio',
  'command',
  'aware',
  'cli',
  'toolbox',
];
